<template>

    <div>

        <div class="jumbotron mb-0 bg-white text-center text-portal-soft-black">
            <p class="display-4 mt-3 h1">
                <i class="fas fa-check-circle message-sent-icon" aria-label="Message Sent" style="color: #A6CE42;"></i>
            </p>
            <p class="lead mt-4">
                <h4 v-once>{{headerText}}</h4>
            </p>

            <p v-once>{{subHeaderText}}</p>

            <p v-once class="text-portal-soft-red">{{subHeaderTextImportant}}</p>

            <p v-once v-html="bodyTextHtml"></p>

            <div v-if="buttonText" class="row mt-3 justify-content-center">
                <div class="col">
                    <button data-dismiss="modal" @click="$emit('button-clicked')" class="btn btn-primary w-100" v-once>{{buttonText}}</button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        name: 'composeMessageSuccess',
        props: {
            headerText: { type: String }, //{{cmsContentBlocks['mainPageSuccessScreenHeader']}}
            subHeaderText: { type: String }, //{{cmsContentBlocks['mainPageSuccessScreenSubHeader']}}
            subHeaderTextImportant: { type: String }, //{{cmsContentBlocks['mainPageSuccessScreenSubHeaderImportant']}}
            bodyTextHtml: { type: String }, //{{cmsContentBlocks['mainPageSuccessBodyTextHtml']}}
            buttonText: { type: String } //{{cmsContentBlocks['mainPageSuccessScreenOkButton']}}
        }
    };
</script>

